import _ from 'lodash'
import { GetterTree } from 'vuex'
import UIState, { UIGetters } from '@/store/ui/types'
import { RootState, RootGetters } from '@/store/types'
import Search from '@/util/Search'
import Entry from '@/data/entry-model'
import { Dictionary } from '@/types/general'

const getters: GetterTree<UIState, RootState> = {
    /**
     * Whether the tree is toggleable based on interface size
     */
    canToggleTree({ size }): boolean {
        return size !== 'lg-desktop'
    },

    /**
     * Whether the interface size is small enough to use
     * page mode
     */
    usingPages({ size }): boolean {
        return size === 'mobile' || size === 'tablet'
    },

    /**
     * Whether the user is currently searching
     */
    searching({ searchTerm }): boolean {
        return searchTerm !== ''
    },

    searchTags({ searchTerm }): string[] {
        const words = searchTerm.split('  ')
        return words.filter(word => word.startsWith('#')).map(word => word.substring(1))
    },

    searchFields({ searchTerm }): Dictionary<string> {
        const words = searchTerm.match(/\w+:[\S]+/i)
        return (words || []).reduce((fields, word) => {
            const [key, value] = word.toLowerCase().split(':')
            return { ...fields, [key]: value }
        }, {})
    },

    cleanSearchTerm({ searchTerm }): string {
        return searchTerm
            .replace(/\s*#\w+/, '')
            .replace(/\s*\w+:[\S]+/, '')
    },

    /**
     * The results of the search
     */
    searchResults(
        _s,
        { cleanSearchTerm, searchTags, searchFields }: UIGetters,
        _rs,
        { visibleEntries }: RootGetters
    ): Entry[] {
        if (cleanSearchTerm === ''
            && searchTags.length === 0
            && Object.keys(searchFields).length === 0) {
            return []
        }

        return visibleEntries
            .map(entry => ({
                entry,
                score: Search.score(
                    cleanSearchTerm,
                    entry,
                    searchTags,
                    searchFields
                )
            }))
            .filter(({ score }) => score > 0)
            .sort((a, b) => b.score - a.score)
            .map(({ entry }) => entry)
            .slice(0, 10)
    }
}

export default getters
